import React from "react"
import PropTypes from "prop-types"
import { Link, graphql, StaticQuery } from "gatsby"
import logoImg from "../img/logo-EA.png"

if (typeof window !== `undefined`) {
  window.postsToShow = 6
}

class DsaRoll extends React.Component {
  constructor(props) {
    super(props)
    let postsToShow = 6
    if (typeof window !== `undefined`) {
      postsToShow = window.postsToShow
    }
    this.state = {
      showingMore: postsToShow > 6,
      postsToShow,
    }
  }

  update() {
    const distanceToBottom =
      document.documentElement.offsetHeight -
      (window.scrollY + window.innerHeight)
    if (this.state.showingMore && distanceToBottom < 100) {
      this.setState({ postsToShow: this.state.postsToShow + 12 })
    }
    this.ticking = false
  }

  handleScroll = () => {
    if (!this.ticking) {
      this.ticking = true
      requestAnimationFrame(() => this.update())
    }
  }

  componentDidMount() {
    window.addEventListener(`scroll`, this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener(`scroll`, this.handleScroll)
    window.postsToShow = this.state.postsToShow
  }

  render() {
    const index = this.state.postsToShow
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    // console.log(posts)
    return (
      <div className="relative px-4 pt-2 bg-gray-50 lg:mx-20 sm:px-6 lg:pt-8 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-white h-1/3 sm:h-2/3" />
        </div>
        <div className="relative mx-auto max-w-8xl">
          <div className="grid max-w-lg mx-auto my-2 gap-7 lg:grid-cols-3 lg:max-w-none">
            {posts &&
              posts.slice(0, index).map(({ node: post }) => (
                <Link
                  to={post.frontmatter.path}
                  className="h-full"
                  key={post.id}
                >
                  <div className="flex flex-col h-full overflow-hidden rounded-lg shadow-lg">
                    {post.frontmatter.featuredimage ? (
                      <div className="flex-shrink-0">
                        <img
                          className="object-cover w-full h-full"
                          src={require("../../static/" +
                            post.frontmatter.featuredimage)}
                          alt=""
                        />
                      </div>
                    ) : null}
                    <div className="flex flex-col justify-between flex-1 p-6 bg-white">
                      <div className="flex-1">
                        <a href="#" className="block">
                          <Link
                            className="mt-2 text-xl font-semibold leading-7 text-gray-900"
                            to={post.frontmatter.path}
                          >
                            {" "}
                            {post.frontmatter.title}{" "}
                          </Link>

                          <p className="mt-3 text-sm leading-6 text-gray-500">
                            {post.excerpt}
                          </p>
                        </a>
                      </div>
                      <div className="flex items-center mt-6">
                        <div className="flex-shrink-0">
                          <a href="#">
                            <img
                              className="w-10 h-10 rounded-full"
                              src={logoImg}
                              alt=""
                            />
                          </a>
                        </div>
                        <div className="ml-3">
                          <p className="text-sm font-medium leading-5 text-gray-900">
                            <a href="#" className="-mt-1 hover:underline">
                              {/* {post.frontmatter.author} */}
                              EnjoyAlgorithms
                            </a>
                          </p>
                          <div className="mt-1.5 text-sm leading-5 text-gray-500">
                            <time dateTime="2020-03-16">
                              {post.frontmatter.date}
                            </time>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
          </div>

          {this.state.postsToShow <
            this.props.data.allMarkdownRemark.edges.length &&
            !this.state.showingMore && (
              <div className="flex justify-center mt-10 -mb-6">
                <button
                  className="px-3 py-2 font-bold prose text-white bg-green-500 border rounded-md hover:bg-green-400"
                  onClick={() => {
                    this.setState({
                      postsToShow: this.state.postsToShow + 3,
                      showingMore: true,
                    })
                  }}
                >
                  Explore More
                </button>
              </div>
            )}
        </div>
      </div>
    )
  }
}

DsaRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
      query DsaRollQuery {
        allMarkdownRemark(
          filter: {
            frontmatter: { visibility: { eq: true }, category: { eq: "dsa" } }
          }
          sort: { order: DESC, fields: frontmatter___date }
        ) {
          edges {
            node {
              excerpt(pruneLength: 150)
              frontmatter {
                tags
                path
                description
                date(formatString: "DD MMMM YYYY")
                category
                author
                title
                reviewer
                featuredimage
                visibility
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <DsaRoll data={data} count={count} />}
  />
)
